module.exports = __webpack_public_path__ + "static/media/2.e44f88b6.png";